import { Parser } from "@siteimprove/alfa-parser";
import { Token } from "../../syntax/index.js";
import { Numeric } from "./numeric.js";
const { map } = Parser;
/**
 * {@link https://drafts.csswg.org/css-values/#integers}
 *
 * @public
 */
export class Integer extends Numeric {
    /**
     * {@link https://drafts.csswg.org/css-values/#css-round-to-the-nearest-integer}
     */
    static of(value) {
        // Math.round ensure the correct rounding.
        // The bitwise or ensure coercion to 32 bits integer
        return new Integer(Math.round(value) | 0);
    }
    constructor(value) {
        super(value, "integer");
    }
    scale(factor) {
        return new Integer(this._value * factor);
    }
    equals(value) {
        return value instanceof Integer && super.equals(value);
    }
    hash(hash) {
        hash.writeInt32(this._value);
    }
    toJSON() {
        return super.toJSON();
    }
}
/**
 * @public
 */
(function (Integer) {
    function isInteger(value) {
        return value instanceof Integer;
    }
    Integer.isInteger = isInteger;
    Integer.parse = map(Token.parseNumber((number) => number.isInteger), (integer) => Integer.of(integer.value));
})(Integer || (Integer = {}));
//# sourceMappingURL=integer.js.map